import React from "react";
import "./InformativeCard.css";

const Card = ({ title, subtitle, icon, children, onClick, background, color, dismissible, onDismiss }) => {
  return (
    <div
      className="dashboard-card"
      style={{
        background: background || "#fff",
        color: color || "#111",
        cursor: onClick ? "pointer" : "default",
        position: "relative",
      }}
      onClick={onClick}
    >
      {dismissible && (
        <button
          className="dismiss-button"
          onClick={(e) => {
            e.stopPropagation(); // Card tıklamasını engelle
            onDismiss?.(); // Varsa callback'i çalıştır
          }}
        >
          ✖
        </button>
      )}

      {title && icon && subtitle && (
        <div className="dashboard-card-header">
          {icon && <div className="dashboard-card-icon">{icon}</div>}
          {title && subtitle && (
            <div className="dashboard-card-text">
              <h3>{title}</h3>
              {subtitle && <p>{subtitle}</p>}
            </div>
          )}
        </div>
      )}

      {children && <div className="dashboard-card-body">{children}</div>}
    </div>
  );
};

export default Card;
